import React from 'react';

import { Container } from './styles';

const Dropdown: React.FC = ({ children }) => {
  return (
    <Container>
      <ul>{children}</ul>
    </Container>
  );
};

export default Dropdown;
